export default __webpack_public_path__ + "static/media/Yy.d9f0a185.wav";